import { makeRequest } from "../http-common";

const TaskDataService = {
    async getAll(statuscodes, assignee, sorting, limit) {
        let url = `/task/list/?ref_status_id=${statuscodes}&sortby=${sorting}&limit=${limit}`;
        if (assignee) {
            url += `&assignee=${assignee}`;
        }
        return makeRequest('get', url);
    },

    async getById(id) {
        return makeRequest('get', `/task/${id}`);
    },

    async getAllbyRef(ref, column) {
        return makeRequest('get', `/task/list/?${column}=${ref}&assignee=any&ref_status_id=1,2,3,4,5`);
    },

    async getTaskCounts() {
        return makeRequest('get', `/task/counts`);
    },

    async getDistribution() {
        return makeRequest('get', `/task/distribution`);
    },

    create(data) {
        return makeRequest('post', '/task', data);
    },

    update(id, data) {
        return makeRequest('put', `/task/${id}`, data);
    },

    delete(id) {
        return makeRequest('delete', `/task/${id}`);
    }
};

export default TaskDataService;